(() => {
  function compactBenefits(copy, blocks) {
    const benefits = blocks[2];
    const candidates = Array.from(benefits.querySelectorAll('p,li,span')).filter(element => /^[✅✓✔]\s*\S/.test(element.textContent.trim()));
    const selected = candidates.filter(element => !candidates.some(other => other !== element && other.contains(element))).slice(0, 4);
    if (selected.length !== 4) return;
    const title = document.createElement('p');
    title.className = 'sgp-description-card-title';
    const strong = document.createElement('strong');
    strong.textContent = copy.dataset.sgpBenefitsTitle;
    title.appendChild(strong);
    const list = document.createElement('div');
    list.className = 'sgp-benefit-lines';
    selected.forEach(element => {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (!node.textContent.trim()) continue;
        node.textContent = node.textContent.replace(/^\s*[✅✓✔]\s*/, '');
        break;
      }
      element.classList.add('sgp-benefit-line');
      list.appendChild(element);
    });
    Array.from(benefits.querySelectorAll('p,h2,h3,h4,div,strong')).filter(element => /^(pourquoi[^✅✓✔]*[:?]|à retenir)$/i.test(element.textContent.trim())).forEach(element => element.remove());
    Array.from(benefits.children).forEach(element => {
      if (element.textContent.trim() || element.querySelector('img,video,iframe')) {
        element.classList.add('sgp-description-extra');
        blocks[1].appendChild(element);
      } else element.remove();
    });
    benefits.append(title, list);
    benefits.classList.add('sgp-benefits-compact');
  }
  function fourBlocks(copy, flow) {
    if (copy.dataset.sgpPhysical !== 'true') return;
    const originals = Array.from(flow.children).filter(element => element.matches('.sgp-description-card,.sgp-description-tagline'));
    const blocks = Array.from({length:4}, (_, index) => {
      const block = document.createElement('div');
      block.className = 'sgp-description-card' + (index === 0 ? ' sgp-description-intro' : '');
      block.dataset.sgpBlock = String(index + 1);
      return block;
    });
    const text = element => element.textContent.trim().toLocaleLowerCase('fr');
    originals.forEach((element, index) => {
      let destination = 1;
      if (index === 0) destination = 0;
      else if (element.matches('.why,.ideal,.sgp-description-tagline') || /^(pourquoi\b|idéale? pour\b|à retenir\b)/.test(text(element))) destination = 2;
      else if (/^(ce que vous recevez\b|à savoir\s*:|comment ça fonctionne\s*\?)/.test(text(element))) destination = 3;
      element.classList.remove('sgp-description-card', 'sgp-description-intro');
      element.classList.add('sgp-description-segment');
      blocks[destination].appendChild(element);
    });
    blocks.forEach((block, index) => {
      if (!block.children.length) {
        const fallback = copy.querySelector('[data-sgp-fallback="' + (index + 1) + '"]');
        if (fallback) block.appendChild(fallback.content.cloneNode(true));
      }
      flow.appendChild(block);
    });
    compactBenefits(copy, blocks);
    flow.classList.add('sgp-description-four-blocks');
  }
  function normalizeDescription(copy) {
    if (copy.dataset.sgpDescriptionReady) return;
    copy.dataset.sgpDescriptionReady = 'true';
    const content = element => !element.matches('style,script,template') && (element.textContent.trim() || element.querySelector('img,video,iframe,svg,table,input'));
    const children = Array.from(copy.children).filter(content);
    let flow = copy;
    if (children.length === 1 && children[0].matches('div') && !children[0].style.background && !children[0].style.border) flow = children[0];
    flow.classList.add('sgp-description-flow');
    Array.from(flow.children).forEach(element => {
      if (element.matches('p') && !content(element)) element.remove();
    });
    const nodes = Array.from(flow.children).filter(content);
    const isHeading = element => (copy.dataset.sgpPhysical === 'true' && element.matches('div') && !element.children.length && /^à retenir$/i.test(element.textContent.trim())) || element.matches('h2,h3,h4') || (element.matches('p') && element.children.length === 1 && element.firstElementChild.matches('strong,b') && element.textContent.trim() === element.firstElementChild.textContent.trim());
    nodes.forEach((element, index) => {
      const next = nodes[index + 1];
      if (isHeading(element) && next && next.matches('div,section,aside')) {
        element.classList.add('sgp-description-card-title');
        next.prepend(element);
      }
    });
    let paragraphCard = null;
    Array.from(flow.childNodes).forEach(node => {
      if (node.nodeType === 3 && !node.textContent.trim()) return;
      if (node.nodeType !== 1 && node.nodeType !== 3) return;
      if (node.nodeType === 1 && node.matches('style,script,template')) return;
      const standalone = node.nodeType === 1 && node.matches('div,section,aside,blockquote,table');
      if (standalone) {
        node.classList.add('sgp-description-card');
        paragraphCard = null;
        return;
      }
      if (!paragraphCard) {
        paragraphCard = document.createElement('div');
        paragraphCard.className = 'sgp-description-card';
        flow.insertBefore(paragraphCard, node);
      }
      paragraphCard.appendChild(node);
    });
    const cards = Array.from(flow.querySelectorAll(':scope > .sgp-description-card'));
    const heading = card => card.textContent.trim().toLocaleLowerCase('fr');
    const benefits = cards.find(card => card.matches('.why') || /^pourquoi\b/.test(heading(card)));
    const usage = cards.find(card => card.matches('.ideal') || /^idéale? pour\b/.test(heading(card)));
    const delivery = cards.find(card => /^ce que vous recevez\b/.test(heading(card)));
    const details = cards.filter(card => /^à savoir\s*:|^comment ça fonctionne\s*\?/.test(heading(card)));
    const merge = (target, source) => {
      if (!target || !source || target === source) return;
      source.classList.remove('sgp-description-card');
      source.classList.add('sgp-description-part');
      target.appendChild(source);
    };
    merge(benefits, usage);
    details.forEach(card => merge(delivery, card));
    cards.forEach(card => {
      if (card.matches('blockquote,.tagline')) {
        card.classList.remove('sgp-description-card');
        card.classList.add('sgp-description-tagline');
      }
    });
    const first = flow.querySelector(':scope > .sgp-description-card');
    if (first) first.classList.add('sgp-description-intro');
    fourBlocks(copy, flow);
  }
  function initialize() {
    document.querySelectorAll('[data-sgp-description]').forEach(normalizeDescription);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
